
    import '/home/ec2-user/Youlify-Design/components/app/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["app-demo-basic","app-demo-config"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/app/index.en-US.md?type=demo')
};